import { apiRequest, requestSessionLogout } from './http'
import type { AuthResponse, LoginRequest, RegisterRequest, User } from '@/types/auth'

export const authApi = {
  requestRecovery(account: string) {
    return apiRequest<boolean>({ method: 'POST', url: '/auth/password-recovery', data: { account } })
  },
  changePassword(payload: { currentPassword: string; newPassword: string }) {
    return apiRequest<boolean>({ method: 'POST', url: '/users/me/password', data: payload })
  },
  register(payload: RegisterRequest) {
    return apiRequest<AuthResponse>({ method: 'POST', url: '/auth/register', data: payload })
  },
  login(payload: LoginRequest) {
    return apiRequest<AuthResponse>({ method: 'POST', url: '/auth/login', data: payload })
  },
  adminLogin(payload: LoginRequest) {
    return apiRequest<AuthResponse>({ method: 'POST', url: '/admin/auth/login', data: payload })
  },
  me() {
    return apiRequest<User>({ method: 'GET', url: '/users/me' })
  },
  updateProfile(payload: { displayName: string }) {
    return apiRequest<User>({ method: 'PATCH', url: '/users/me', data: payload })
  },
  logout(token: string) {
    return requestSessionLogout(token)
  },
}
